import { Code2, FileText, TerminalSquare } from 'lucide-react';

const metrics = [
  { label: 'Backend', value: 'APIs' },
  { label: 'Cloud', value: 'AWS' },
  { label: 'Foco', value: 'Escala' },
];

export function ProfileSummary() {
  return (
    <aside className="profile-panel" aria-label="Resumen profesional">
      <div className="terminal-window">
        <div className="terminal-topbar">
          <span />
          <span />
          <span />
        </div>
        <pre>{`$ perfil --backend
stack: Node.js | Java | SQL | AWS
prioridad: sistemas simples de operar
estado: abierto a oportunidades`}</pre>
      </div>

      <div className="metric-row">
        {metrics.map((metric) => (
          <div key={metric.label}>
            <strong>{metric.value}</strong>
            <span>{metric.label}</span>
          </div>
        ))}
      </div>

      <div className="profile-links">
        <span>
          <Code2 size={16} /> Codigo limpio
        </span>
        <span>
          <TerminalSquare size={16} /> CI/CD
        </span>
        <span>
          <FileText size={16} /> Docs tecnicas
        </span>
      </div>
    </aside>
  );
}
